export const colors = {
  primary90: '#0c2d48',
  primary80: '#0b395d',
  primary70: '#0b4573',
  primary60: '#0d5189',
  primary50: '#145da0',
  primary40: '#367bb1',
  primary30: '#5c99c1',
  primary20: '#85b7d0',
  primary10: '#b1d4e0',

  secondary90: '#ca3f36',
  secondary80: '#d35239',
  secondary70: '#db633e',
  secondary60: '#e37443',
  secondary50: '#eb844a',
  secondary40: '#f79b77',
  secondary30: '#fdb5a1',
  secondary20: '#fdd0c8',
  secondary10: '#f7eceb',

  accent1: '#d45e95',
  accent2: '#b290d4',
  accent3: '#97b8e6',

  // 10 shades of grey
  black: '#1E2025',
  charcoal: '#262830',
  shadow: '#2E313A',
  lead: '#585965',
  steel: '#787C8A',
  gray: '#989DAC',
  smoke: '#BEC2C9',
  fog: '#EDEEF0',
  white: '#F6F7F9',
  snow: '#FCFCFC',

  // slate
  slateLight: '#3279AD',
  slate: '#4C6E89',
  slateDark: '#455C77',

  // teal
  teal: '#3D829C',
  tealDark: '#36768B',

  // laguna
  lagunaLight: '#4FB8F3',
  laguna: '#57A7E3',
  lagunaDark: '#3680DC',

  // warm colors
  red: '#F60C5B',
  orange: '#F86C5C',
  sunflower: '#EDC172',
  lemon: '#FFE362',

  // purples
  grape: '#374278',
  plum: '#725FA4',
  lavender: '#936FBA',
  purple: '#C163C6',

  // greens
  forest: '#50C04E',
  lawn: '#86DE6A',
  aquamarine: '#14DAB5',
  emerald: '#0DCACE',
  turquoise: '#57D5D6',

  // browns
  chocolate: '#3C322D',
  barnwood: '#5E5E5F',
};

export default colors;
